import { ApiCompetition } from "../types";

export default function getCanEnterCompetition(
  competition: ApiCompetition
): [boolean | undefined, string] {
  return [
    competition.canEnter ?? undefined,
    competition.canEnterReason?.message ?? "",
  ];
}
